module.exports = __webpack_public_path__ + "img/SES_120260002.c7f53106.jpg";